﻿const axios = require('axios');
import FileUpload from './components/FileUpload.vue';
import datatable from './components/dataTable.vue';
import { required, requiredIf, email, integer, maxLength, minLength, helpers } from '@vuelidate/validators';
import { useVuelidate } from '@vuelidate/core';
import Tab from './components/tabs/tab.vue';
import Tabs from './components/tabs/tabs.vue';
import datePicker from 'vanillajs-datepicker/Datepicker';
import nl from 'vanillajs-datepicker/locales/nl';
Object.assign(datePicker.locales, nl);

const dutchPostal = helpers.regex(/^[1-9][0-9]{3} ?(?!sa|sd|ss|SA|SD|SS)[A-Za-z]{2}$/);
function validateIf(condition, rule) {
    return condition ? rule : {};
}

const today = new Date();
const yesterday = new Date(today.setDate(today.getDate() - 1));
const hundredYearsAgo = new Date();
hundredYearsAgo.setFullYear(hundredYearsAgo.getFullYear() - 100);
let maxdate = yesterday.toLocaleDateString('nl-NL', { year: 'numeric', month: 'short', day: '2-digit' });
let minbirthdate = hundredYearsAgo.toLocaleDateString('nl-NL', { year: 'numeric', month: 'short', day: '2-digit' });
const dutchMonths = new Map([...Array(12)].map((x, i) => [new Date(2022, i, 1, 0, 0, 0, 0).toLocaleDateString('nl-NL', { month: 'short' }).slice(0, 3), i]));
const birthOptions = {
    autohide: true,
    format: 'dd-M-yyyy',
    maxDate: maxdate,
    minDate: minbirthdate,
    language: 'nl',
    nextArrow: '>',
    prevArrow: '<',
    startView: 2,
    orientation: 'top'
}

const dateOptions = {
    autohide: true,
    format: 'dd-M-yyyy',
    maxDate: maxdate,
    language: 'nl',
    nextArrow: '>',
    prevArrow: '<',
    orientation: 'top'
}

const claimCreateApp = {
    setup: () => ({ v$: useVuelidate() }),
    components: {
        FileUpload,
        datatable,
        Tab,
        Tabs
    },
    data() {
        return {
            loading: false,
            isMounted: false,
            header: null,
            menu: null,
            api: '',
            upload: '',
            claimantApi: '',
            referenceApi: '',
            claimantArray: [],
            allowClaim: false,
            redirectUrl: '/',
            redirectUrlAtStep1: '/',
            step: 1,
            uploadStep: 1,
            formData: {},
            hasError: false,
            dataStep1: {
                typeAlias: ''
            },
            datepickers: [],
            excelDatepickers: [],
            defaultCustomerType: 'N',
            defaultTypeInvoiceAddress: 'varChoiceDutchAddress',
            defaultCountry: 'NL',
            defaultFinalClaimStep: 'varChoiceFinalStep_End',
            step1: {
                CustomerType: '',
                TypeInvoiceAddress: '',
                Claimant: '',
                ClientReference: '',
                Initials: '',
                MiddleName: '',
                LastName: '',
                Birthdate: '',
                ChamberOfCommerceNumberNP: '',
                BusinessName: '',
                ChamberOfCommerceNumberRP: '',
                Street: '',
                HouseNumber: '',
                HouseNumberAddition: '',
                Postalcode: '',
                City: '',
                Country: '',
                Phone: '',
                EmailAddress: '',
                BankAccount: '',
                InvoiceNumber: '',
                ClaimDescription: '',
                InvoiceAmount: '',
                InvoiceAmountDecimal: '',
                InvoiceDate: '',
                ClaimExpirationDate: '',
                AmountPaidToClaimant: '',
                DateOfAmountPaidToClaimant: '',
                AmountPaidToClaimantDecimal: '',
            },
            step2: {
                uploadFiles: [],
                fileIDs: [],
                key: 0,
            },
            step3: { },
            step4: {
                FinalClaimStep: '',
            },
            uploadStep1: {
                Claimant: '',
                fileIDs: []
            },
            uploadStep2: {
                exceldata: {
                    errorMessage: '',
                    excelSheetClaims: []
                },
                refsInUse: false,
                invalid: false
            },
            dropdown: false,
            claimList: [],
            currentMemberOnly: true
        }
    },
    validations() {
        return {
            step1: {
                CustomerType: { required },
                TypeInvoiceAddress: { required },
                Claimant: { required },
                ClientReference: { required },
                Initials: {
                    required: requiredIf(function () {
                        return this.step1.CustomerType === this.defaultCustomerType
                    })
                },
                LastName: {
                    required: requiredIf(function () {
                        return this.step1.CustomerType === this.defaultCustomerType
                    })
                },
                Birthdate: {
                    between(date) {
                        if (!date.length) return true;
                        let dateObj = this.getDateFromString(date);
                        return dateObj > hundredYearsAgo && dateObj < today
                    }
                },
                BusinessName: {
                    required: requiredIf(function () {
                        return this.step1.CustomerType !== this.defaultCustomerType
                    })
                },
                ChamberOfCommerceNumberRP: {
                    required: requiredIf(function () {
                        return this.step1.CustomerType !== this.defaultCustomerType
                    })
                },
                Street: { required },
                HouseNumber: { required },
                Postalcode: {
                    required,
                    ...validateIf(this.step1.TypeInvoiceAddress === this.defaultTypeInvoiceAddress, { dutchPostal })
                },
                City: { required },
                Country: {
                    required: requiredIf(function () {
                        return this.step1.TypeInvoiceAddress !== this.defaultTypeInvoiceAddress
                    })
                },
                EmailAddress: { email },
                InvoiceNumber: { required },
                InvoiceAmount: {
                    required,
                    integer,
                    aboveZero: function () {
                        return this.checkAmount(this.step1.InvoiceAmount, this.step1.InvoiceAmountDecimal)
                    }
                },
                InvoiceAmountDecimal: {
                    required: requiredIf(function () {
                        return this.step1.InvoiceAmount !== ''
                    }),
                    integer,
                    maxLength: maxLength(2),
                    minLength: minLength(2)
                },
                InvoiceDate: {
                    required,
                    maxValue(date) {
                        let dateObj = this.getDateFromString(date);
                        return dateObj < yesterday
                    }
                },
                ClaimExpirationDate: {
                    between(date) {
                        if (!date.length) return true;
                        if (!this.step1.InvoiceDate.length) return true;
                        let dateObj = this.getDateFromString(date);
                        let invoiceDateObj = this.getDateFromString(this.step1.InvoiceDate);
                        return dateObj < yesterday && dateObj > invoiceDateObj
                    }
                },
                AmountPaidToClaimant: {
                    integer,
                    between(val) {
                        if (!val.length || !this.step1.InvoiceAmount.length) return true
                        return parseFloat(val + '.' + this.step1.AmountPaidToClaimantDecimal) <= parseFloat(this.step1.InvoiceAmount + '.' + this.step1.InvoiceAmountDecimal) && parseFloat(val + '.' + this.step1.AmountPaidToClaimantDecimal) > 0
                    }
                },
                AmountPaidToClaimantDecimal: {
                    required: requiredIf(function () {
                        return this.step1.AmountPaidToClaimant !== ''
                    }),
                    integer,
                    maxLength: maxLength(2),
                    minLength: minLength(2)
                },
                DateOfAmountPaidToClaimant: {
                    required: requiredIf(function () {
                        return this.step1.AmountPaidToClaimant !== '' && parseFloat(this.step1.AmountPaidToClaimant + '.' + this.step1.AmountPaidToClaimantDecimal) > 0
                    }),
                    between(date) {
                        if (!date.length) return true;
                        if (!this.step1.InvoiceDate.length) return true;
                        let dateObj = this.getDateFromString(date);
                        let invoiceDateObj = this.getDateFromString(this.step1.InvoiceDate);
                        return dateObj < yesterday && dateObj > invoiceDateObj
                    }
                }
            },
            step4: {
                FinalClaimStep: { required }
            },
            uploadStep1: {
                Claimant: { required }
            },
            uploadStep2: {
                exceldata: {
                    excelSheetClaims: {
                        $each: helpers.forEach({
                            uwReferentie: { required },
                            soortRelatie: { required },
                            naam: { required },
                            voorletters: {
                                required: requiredIf(function (val, obj) {
                                    return obj.soortRelatie === this.defaultCustomerType
                                })
                            },
                            geboortedatum: {
                                between(date) {
                                    if (!date.length) return true;
                                    let dateObj = this.getDateFromString(date);
                                    return dateObj > hundredYearsAgo && dateObj < today
                                }
                            },
                            straat: { required },
                            postcode: {
                                required,
                                validNL: function (val, obj) {
                                    if (obj.land !== 'NL') return true;
                                    const pat = /^[1-9][0-9]{3} ?(?!sa|sd|ss|SA|SD|SS)[A-Za-z]{2}$/;
                                    return pat.test(val)
                                }
                            },
                            huisnr: { required },
                            plaats: { required },
                            land: { required },
                            emailadres: { email },
                            kvKNummer: {
                                required: requiredIf(function (val, obj) {
                                    return obj.soortRelatie !== this.defaultCustomerType
                                })
                            },
                            factuurnummer: { required },
                            factuurbedrag: {
                                required,
                                integer: function (val) {
                                    if (!val.length) return true
                                    return !isNaN(parseFloat(val))
                                },
                                aboveZero: function (val, obj) {
                                    return parseFloat(val) > 0
                                }
                            },
                            factuurdatum: {
                                required,
                                maxValue(date) {
                                    if (!date.length) return true;
                                    let dateObj = this.getDateFromString(date);
                                    return dateObj < yesterday
                                }
                            },
                            vervaldatum: {
                                between: function (date, obj) {
                                    if (!date.length) return true;
                                    if (!obj.factuurdatum.length) return true;
                                    let dateObj = this.getDateFromString(date);
                                    let invoiceDateObj = this.getDateFromString(obj.factuurdatum);
                                    return dateObj < yesterday && dateObj > invoiceDateObj
                                }
                            },
                            reedsBetaald: {
                                integer: function (val) {
                                    if (!val.length) return true
                                    return !isNaN(parseFloat(val))
                                },
                                between: function (val, obj) {
                                    if (!val.length || !obj.factuurbedrag.length) return true
                                    return parseFloat(val) <= parseFloat(obj.factuurbedrag) && parseFloat(val) > 0
                                }
                            },
                            betaaldatum: {
                                required: requiredIf(function (val, obj) {
                                    return obj.reedsBetaald !== '' && parseFloat(obj.reedsBetaald) > 0
                                }),
                                between: function(date, obj) {
                                    if (!date.length) return true;
                                    if (!obj.factuurdatum.length) return true;
                                    let dateObj = this.getDateFromString(date);
                                    let invoiceDateObj = this.getDateFromString(obj.factuurdatum);
                                    return dateObj < yesterday && dateObj > invoiceDateObj
                                }
                            }
                        })
                    }
                }
            }
        }
    },
    watch: {
        "step1.CustomerType": function (newVal, oldVal) {
            if (oldVal !== newVal) {
                if (newVal === this.defaultCustomerType) {
                    this.step1.BusinessName = '';
                    this.step1.ChamberOfCommerceNumberRP = '';
                } else {
                    this.step1.Initials = '';
                    this.step1.MiddleName = '';
                    this.step1.LastName = '';
                    this.step1.Birthdate = '';
                    this.step1.ChamberOfCommerceNumberNP = '';
                }
            }
        },
        "step1.InvoiceAmount": function(newVal, oldVal) {
            if (oldVal === '' && newVal !== '') {
                if (this.step1.InvoiceAmountDecimal === '') this.step1.InvoiceAmountDecimal = '00';
            }
            if (newVal === '') this.step1.InvoiceAmountDecimal = '';
        },
        "step1.AmountPaidToClaimant": function(newVal, oldVal) {
            if (oldVal === '' && newVal !== '') {
                if (this.step1.AmountPaidToClaimantDecimal === '') this.step1.AmountPaidToClaimantDecimal = '00';
            }
            if (newVal === '') this.step1.AmountPaidToClaimantDecimal = '';
        },
        "step1.TypeInvoiceAddress": function (val) {
            if (val === this.defaultTypeInvoiceAddress) {
                this.step1.Country = this.defaultCountry;
            } else {
                this.step1.Country = '';
            }
        },
        multiUpload(val) {
            this.uploadStep1.fileIDs = val;
        }
    },
    computed: {
        multiUpload() {
            if (!this.isMounted || !this.allowClaim) return;
            return this.$refs.fileUploadMultiple.fileIDs;
        }
    },
    methods: {
        getDateFromString(dateString) {
            if (!dateString.length) return new Date()
            const i = dateString.replaceAll('/', '-').split('-');
            let dt = null;
            if (isNaN(i[1])) {
                dt = new Date(i[2], dutchMonths.get(i[1].slice(0, 3)), i[0]);
            } else {
                dt = new Date(i[2], i[1]-1, i[0]);
            }
            return new Date(dt - dt.getTimezoneOffset() * 60000)
        },
        setClaimQuery(val) {
            this.currentMemberOnly = val;
            this.$refs.claims.queryModel.currentMemberOnly = val;
            this.$refs.claims.loading = true;
            this.$refs.claims.getData();
            this.dropdown = false;
        },
        setDateRef(el) {
            if (el) {
                if (el.classList.contains('exceldate')) {
                    if (!this.excelDatepickers.some(e => e.id === el.id)) this.excelDatepickers.push(el);
                } else {
                    if (!this.datepickers.some(e => e.id === el.id)) this.datepickers.push(el);
                }
            }
        },
        getClaimantFromValue(val) {
            if (val === '') return '';
            let claimant = this.claimantArray.find(claimant => {
                return claimant.value === val
            });
            return claimant.name
        },
        initCalendars(calendars) {
            calendars.forEach(calendar => {
                let format = calendar.dataset.showformat;
                if (calendar.classList.contains('birthdate')) {
                    birthOptions.format = format;
                    new datePicker(calendar, birthOptions);
                } else {
                    dateOptions.format = format;
                    new datePicker(calendar, dateOptions);
                }
                calendar.addEventListener('changeDate', (e) => {
                    calendar.dispatchEvent(new Event('input', { bubbles: true }));
                    e.target.blur();
                });
            });
        },
        resetCalendars(calendars) {
            calendars.forEach(calendar => {
                calendar.datepicker.destroy();
            });
        },
        calcTotal() {
            if (this.step1.AmountPaidToClaimant === '') {
                return this.step1.InvoiceAmount + ',' + this.step1.InvoiceAmountDecimal
            } else {
                let invoiceAmount = parseFloat(this.step1.InvoiceAmount + '.' + this.step1.InvoiceAmountDecimal);
                let paidAmount = parseFloat(this.step1.AmountPaidToClaimant + '.' + this.step1.AmountPaidToClaimantDecimal);
                let total = invoiceAmount - paidAmount;
                return total.toFixed(2).toString().replace('.', ',')
            }
        },
        checkAmount(val1, val2) {
            return parseFloat(val1 + '.' + val2) > 0;
        },
        scrollTo($elm) {
            window.scrollTo({ top: $elm.getBoundingClientRect().top + window.pageYOffset - this.header.offsetHeight - this.menu.offsetHeight - 20, behavior: 'smooth' });
        },
        resetErrors(e) {
            this.v$.$reset();
        },
        async submitStep() {
            this.resetErrors(null);
            if (this.step === 1) {
                if (this.step1.TypeInvoiceAddress === this.defaultTypeInvoiceAddress && this.step1.Country !== this.defaultCountry) {
                    this.step1.Country = this.defaultCountry;
                }
                const valid1 = await this.v$.step1.$validate();
                if (!valid1) {
                    this.$nextTick(() => {
                        let $error = document.querySelector('.form-error');
                        if ($error) this.scrollTo($error.closest('.field'));
                    });
                } else {
                    this.loading = true;
                    this.redirectUrl = this.redirectUrlAtStep1;
                    this.formData = JSON.parse(JSON.stringify(this.step1));
                    if (this.step1.Birthdate !== '') this.formData.Birthdate = this.getDateFromString(this.step1.Birthdate).toISOString();
                    if (this.step1.InvoiceDate !== '') this.formData.InvoiceDate = this.getDateFromString(this.step1.InvoiceDate).toISOString();
                    if (this.step1.ClaimExpirationDate !== '') this.formData.ClaimExpirationDate = this.getDateFromString(this.step1.ClaimExpirationDate).toISOString();
                    if (this.step1.DateOfAmountPaidToClaimant !== '') this.formData.DateOfAmountPaidToClaimant = this.getDateFromString(this.step1.DateOfAmountPaidToClaimant).toISOString();
                    this.loading = false;
                    this.step = 2;
                    this.$nextTick(() => {
                        this.scrollTo(this.$refs.steptop2);
                    });
                }
            } else if (this.step === 2) {
                this.step2.fileIDs = this.$refs.fileUploadClaimCreate.fileIDs;
                this.step2.uploadFiles = this.$refs.fileUploadClaimCreate.processedFiles;
                this.formData.FileIDs = this.step2.fileIDs;
                this.step = 3;
                this.$nextTick(() => {
                    this.scrollTo(this.$refs.steptop3);
                });
            } else if (this.step === 3) {
                this.step = 4;
                this.$nextTick(() => {
                    this.scrollTo(this.$refs.steptop4);
                });
            } else if (this.step === 4) {
                const valid4 = await this.v$.step4.$validate();
                if (!valid4) {
                    this.$nextTick(() => {
                        let $error = document.querySelector('.form-error');
                        if ($error) this.scrollTo($error.closest('.field'));
                    });
                } else {
                    this.formData = {};
                    if (this.step4.FinalClaimStep === this.defaultFinalClaimStep) {
                        location.href = this.redirectUrl;
                    } else if (this.step4.FinalClaimStep === 'varChoiceFinalStep_NewClaimOtherCustomer') {
                        Object.keys(this.step1).forEach(key => {
                            this.step1[key] = '';
                        });
                        this.step1.CustomerType = this.defaultCustomerType;
                        this.step1.TypeInvoiceAddress = this.defaultTypeInvoiceAddress;
                        this.step1.Country = this.defaultCountry;
                        this.step2.fileIDs = [];
                        this.step2.uploadFiles = [];
                        this.step2.key++;
                        this.datepickers = [];
                        this.step = 1;
                        this.$nextTick().then(() => {
                            this.initCalendars(this.datepickers);
                            this.scrollTo(this.$refs.steptop1);
                        });
                    } else {
                        this.step1.ClientReference = '';
                        this.step1.ClaimDescription = '';
                        this.step1.InvoiceAmount = '';
                        this.step1.InvoiceAmountDecimal = '';
                        this.step1.InvoiceDate = '';
                        this.step1.InvoiceNumber = '';
                        this.step1.ClaimExpirationDate = '';
                        this.step1.AmountPaidToClaimant = '';
                        this.step1.DateOfAmountPaidToClaimant = '';
                        this.step1.AmountPaidToClaimantDecimal = '';
                        this.step2.fileIDs = [];
                        this.step2.uploadFiles = [];
                        this.step2.key++;
                        this.datepickers = [];
                        this.step = 1;
                        this.$nextTick().then(() => {
                            this.initCalendars(this.datepickers);
                            this.scrollTo(this.$refs.steptop1);
                        });
                    }
                }
            }
        },
        resetMultiUpload() {
            this.$refs.fileUploadMultiple.fileIDs = [];
            this.$refs.fileUploadMultiple.tempFiles = [];
            this.$refs.fileUploadMultiple.processedFiles = [];
            this.$refs.fileUploadMultiple.v$.$reset();
            this.uploadStep1.Claimant = '';
            this.uploadStep1.uploadFiles = [];
            this.uploadStep1.fileIDs = [];
            this.v$.uploadStep1.$reset();
            this.uploadStep = 1;
        },
        async submitUploadStep() {
            if (this.uploadStep === 1) {
                let validClaimant = await this.v$.uploadStep1.$validate();
                if (validClaimant) {
                    this.loading = true;
                    this.uploadStep2.refsInUse = false;
                    let multiClaimResponse = await this.fetchData('', '/tempfiles/' + this.$refs.fileUploadMultiple.fileIDs[0] + '/exceldata', 'get');
                    if (multiClaimResponse) {
                        if (multiClaimResponse.data.typeAlias === 'Success') {
                            this.uploadStep2.exceldata.errorMessage = multiClaimResponse.data.errorMessage;
                            this.uploadStep2.exceldata.excelSheetClaims = multiClaimResponse.data.excelSheetClaims.map(claim => {
                                return {
                                    ...claim,
                                    geboortedatum: claim.geboortedatum.replaceAll('/', '-'),
                                    factuurdatum: claim.factuurdatum.replaceAll('/', '-'),
                                    vervaldatum: claim.vervaldatum.replaceAll('/', '-'),
                                    betaaldatum: claim.betaaldatum.replaceAll('/', '-'),
                                }
                            });
                            this.uploadStep = 2;
                            this.loading = false;
                            this.$nextTick(() => {
                                this.initCalendars(this.excelDatepickers);
                                this.scrollTo(this.$refs.uploadtop2);
                            });
                        } else {
                            this.hasError = true;
                        }
                    }
                }
            } else {
                this.uploadStep2.invalid = false;
                let validClaims = await this.v$.uploadStep2.exceldata.excelSheetClaims.$validate();
                if (validClaims) {
                    this.loading = true;
                    let claims = this.uploadStep2.exceldata.excelSheetClaims;
                    for (let index = 0; index < claims.length; index++) {
                        let claim = claims[index];
                        let formData = {
                            CustomerType: claim.soortRelatie,
                            TypeInvoiceAddress: claim.land === 'NL' ? 'varChoiceDutchAddress' : 'varChoiceNonDutchAddress',
                            Claimant: this.uploadStep1.Claimant,
                            ClientReference: claim.uwReferentie,
                            Initials: claim.voorletters,
                            MiddleName: claim.tussenvoegsel,
                            LastName: claim.soortRelatie === this.defaultCustomerType ? claim.naam : '',
                            Birthdate: claim.geboortedatum === '' ? '' : this.getDateFromString(claim.geboortedatum).toISOString(),
                            ChamberOfCommerceNumberNP: claim.soortRelatie !== this.defaultCustomerType ? '' : claim.kvKNummer,
                            BusinessName: claim.soortRelatie !== this.defaultCustomerType ? claim.naam : '',
                            ChamberOfCommerceNumberRP: claim.soortRelatie === this.defaultCustomerType ? '' : claim.kvKNummer,
                            Street: claim.straat,
                            HouseNumber: claim.huisnr,
                            HouseNumberAddition: claim.huisnrToevoeging,
                            Postalcode: claim.postcode,
                            City: claim.plaats,
                            Country: claim.land,
                            Phone: claim.telefoonnummer,
                            EmailAddress: claim.emailadres,
                            BankAccount: claim.ibaNnr,
                            InvoiceNumber: claim.factuurnummer,
                            ClaimDescription: claim.omschrijving,
                            InvoiceAmount: claim.factuurbedrag.replace(',', '.').split('.')[0],
                            InvoiceAmountDecimal: claim.factuurbedrag.replace(',', '.').split('.')[1] ? claim.factuurbedrag.replace(',', '.').split('.')[1] : '00',
                            InvoiceDate: claim.factuurdatum === '' ? '' : this.getDateFromString(claim.factuurdatum).toISOString(),
                            ClaimExpirationDate: claim.vervaldatum === '' ? '' : this.getDateFromString(claim.vervaldatum).toISOString(),
                            AmountPaidToClaimant: claim.reedsBetaald === '' ? '' : claim.reedsBetaald.replace(',', '.').split('.')[0],
                            DateOfAmountPaidToClaimant: claim.betaaldatum === '' ? '' : this.getDateFromString(claim.betaaldatum).toISOString(),
                            AmountPaidToClaimantDecimal: claim.reedsBetaald === '' ? '' : claim.reedsBetaald.replace(',', '.').split('.')[1] ? claim.reedsBetaald.replace(',', '.').split('.')[1] : '00',
                        };
                        const response = await this.fetchData(formData, this.api, 'post');
                        if (!response || response.status !== 200) {
                            this.hasError = true;
                        }
                    };
                    this.loading = false;
                    this.uploadStep = 3;
                    this.$nextTick(() => {
                        this.scrollTo(this.$refs.uploadtop3);
                    });
                } else {
                    this.uploadStep2.invalid = true;
                }
            }
        },
        goBack(step) {
            if (step === 1) {
                this.datepickers = [];
            }
            this.loading = false;
            this.step = step;
            this.$nextTick(() => {
                if (step === 1) {
                    this.initCalendars(this.datepickers);
                }
                this.scrollTo(this.$refs['steptop' + step]);
            });
        },
        async submitForm() {
            this.hasError = false;
            this.loading = true;
            const response = await this.fetchData(this.formData, this.api,'post');
            if (response && response.status === 200) {
                this.dataStep1 = response.data;
                this.loading = false;
                if (this.dataStep1.typeAlias === 'Success') {
                    this.redirectUrl += '/' + this.dataStep1.claimID;
                    this.formData = {};
                    this.step = 4;
                    this.$nextTick(() => {
                        this.scrollTo(this.$refs.steptop4);
                    });
                } else {
                    let text = 'Er is iets mis gegaan!\nControleer het formulier en probeer opnieuw';
                    if (confirm(text) == true) {
                        this.resetErrors(null);
                        this.step = 1;
                        this.$nextTick(() => {
                            let $error = document.querySelector('.form-error');
                            if ($error) this.scrollTo($error);
                        });
                    }
                }
            } else {
                this.hasError = true;
            }
        },
        async fetchData(formData, apiUrl, methodType) {
            try {
                const response = await axios({
                    method: methodType,
                    url: apiUrl,
                    data: formData,
                    headers: { 'Content-Type': 'application/json' },
                })
                return response;
            } catch (error) {
                this.hasError = true;
                console.log(error);
            }
        },
        async getClaimants() {
            if (sessionStorage.getItem('user') !== null) {
                this.claimantArray = JSON.parse(sessionStorage.getItem('user')).organisationSoortZaakCodes;
            } else {
                const response = await this.fetchData({}, this.claimantApi, 'get');
                if (response && response.status === 200) {
                    this.claimantArray = response.data;
                } else {
                    this.hasError = true;
                }
            }
        }
    },
    created() {
        if (sessionStorage.getItem('user') !== null) {
            this.allowClaim = JSON.parse(sessionStorage.getItem('user')).organisationAllowNewClaims;
        }
    },
    mounted() {
        this.header = document.getElementById('navbar');
        this.menu = document.getElementById('menu');
        if (this.$el.dataset.api) this.api = this.$el.dataset.api;
        if (this.$el.dataset.upload) this.upload = this.$el.dataset.upload;
        if (this.$el.dataset.claimant) this.claimantApi = this.$el.dataset.claimant;
        if (this.$el.dataset.redirecturltemplate) {
            this.redirectUrl = this.$el.dataset.redirecturltemplate;
            this.redirectUrlAtStep1 = this.redirectUrl;
        }
        if (this.$el.dataset.defaultcountrycode) {
            this.defaultCountry = this.$el.dataset.defaultcountrycode;
        }
        if (this.$el.dataset.defaultcustomertype) {
            this.defaultCustomerType = this.$el.dataset.defaultcustomertype;
            this.step1.CustomerType = this.defaultCustomerType;
        }
        this.step1.Country = this.defaultCountry;
        if (this.$el.dataset.defaulttypeinvoiceaddress) {
            this.defaultTypeInvoiceAddress = this.$el.dataset.defaulttypeinvoiceaddress;
            this.step1.TypeInvoiceAddress = this.defaultTypeInvoiceAddress;
        }
        if (this.$el.dataset.defaultfinalclaimstep) {
            this.defaultFinalClaimStep = this.$el.dataset.defaultfinalclaimstep;
            this.step4.FinalClaimStep = this.defaultFinalClaimStep;
        }
        this.initCalendars(this.datepickers);
        this.getClaimants();
        if (this.$refs.tab3.isActive && this.$refs.claims.data === null) this.$refs.claims.getData();
        this.$nextTick(() => {
            this.isMounted = true;
        });
        this.$watch(
            () => {
                return this.$refs.tab3.isActive
            },
            (val) => {
                if (val) {
                    this.$refs.claims.getData();
                }
            }
        );
    }
}

export default claimCreateApp;
